import { HttpRequest, HttpHandlerFn, HttpErrorResponse, HttpStatusCode } from '@angular/common/http';
import { inject } from '@angular/core';

import { catchError, throwError } from 'rxjs';

import { ProfileService } from '../services';

export function errorInterceptor(request: HttpRequest<unknown>, next: HttpHandlerFn) {
  const profileService = inject(ProfileService);

  return next(request).pipe(
    catchError((errorResponse: Readonly<HttpErrorResponse>) => {
      if (errorResponse.status === HttpStatusCode.Unauthorized) {
        profileService.logout();
      }

      return throwError(() => errorResponse);
    }),
  );
}
